module.exports = __webpack_public_path__ + "static/media/pigs.b2048200.jpg";